import styled from "@emotion/styled";
import anime from 'animejs';
import React from "react";
import IntersectionVisible from 'react-intersection-visible';
import { ReactComponent as Circle } from '../../../static/images/circle.svg';

class Watercolor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      intersectionActive: true
    }
    this.wrapper = React.createRef();
  }
  onShow(entries) {

    anime({
      targets: this.wrapper.current,
      // backgroundPositionX: ['100%', '0%'],
      backgroundPositionX: ['0%', '100%'],
      duration: 1000,
      delay: 500,
      easing: 'steps(17)',
      // direction: 'alternate',
      loop: false,
    })
    this.setState({ intersectionActive: false });
  }
  onHide(entries) {

    // anime({
    //   targets: this.wrapper.current,
    //   // backgroundPositionX: ['0%', '100%'],
    //   backgroundPositionX: '0%',
    //   duration: 10,
    //   easing: 'steps(1)',
    //   // direction: 'alternate',
    //   loop: false,
    // })
  }
  render() {
    const { image } = this.props;
    return (
      <IntersectionVisible onShow={e => this.onShow(e)} onHide={e => this.onHide(e)} active={this.state.intersectionActive} options={{ rootMargin: '-20px 0px -20px 0px' }}>

        <Wrapper image={image}>
          <CircleWrapper className={this.state.intersectionActive ? '' : 'visible'}><Circle /></CircleWrapper>
          <WatercolorMask ref={this.wrapper} />
        </Wrapper>
      </IntersectionVisible>
    )
  }
}

export default Watercolor



// const blur = 10;
// const blurie = 3;
// const transitiondelay = 50;

const CircleWrapper = styled.div`

  position: absolute;
  left: 70%;
  top: 70%;

  svg{
    opacity: 0;
    transition: opacity 500ms;
    transition-delay: 1500ms;
  }
  &.visible{
    svg{
      opacity: 1;
    }
  }
`;

const WatercolorMask = styled.div`

  width: 100vw;
  height: 55vw;

  background-image: url(/images/clip-mask-180.png);
  background-image: url(/images/clip-mask.png);
  background-size: cover;
  background-position-x: -100%;
`;
const Wrapper = styled.div`

  width: 100vw;
  height: 55vw;
  
  position: relative;
  background-image: ${props => `url(${props.image})`};
  background-size: cover;

  .tl-wrapper-status--entering &{
    opacity: 0;
  }
`;